import { LocationStrategy, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import localeSk from '@angular/common/locales/sk';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthInterceptor } from 'angular-auth-oidc-client';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthConfigModule } from './auth/auth-config.module';
import { BASE_PATH as DM_DC_BASE_PATH } from '@jissu-public/jissu-public-dm-dc/shared/data-access-public-dc';
import { BASE_PATH as PUBLIC_UAA_BASE_PATH } from '@jissu-public/jissu-public-dm-dc/shared/data-access-public-uaa';
import { BASE_PATH as DM_IDC_BASE_PATH } from '@jissu-public/jissu-public-dm-dc/shared/data-access-idc';
import { JissuPathLocationStrategy } from '@jissu-public/shared/utils';

registerLocaleData(localeSk);
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthConfigModule,
    LoggerModule.forRoot({
      level: NgxLoggerLevel.WARN,
      serverLogLevel: NgxLoggerLevel.OFF,
      disableConsoleLogging: false,
      enableSourceMaps: true,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    { provide: 'ENVIRONMENT', useValue: environment },
    { provide: LOCALE_ID, useValue: 'sk' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: DM_IDC_BASE_PATH,
      useValue: environment.dcApi,
    },
    {
      provide: DM_DC_BASE_PATH,
      useValue: environment.dcApi,
    },
    {
      provide: PUBLIC_UAA_BASE_PATH,
      useValue: environment.uaaApi,
    },
    { provide: LocationStrategy, useClass: JissuPathLocationStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
